import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/ui/components/TransitionExpand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cbdace6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cbdace6', __exports__)) {
    api.reload('1cbdace6', __exports__)
  }
  
}


export default __exports__